import Model from '@models/model';
import { defineAsyncComponent } from 'vue';

const PurchaseItem = defineAsyncComponent(() => import('@models/purchase-item'));

export const PURCHASE_ORDER_STATUS_APPROVAL_REQUIRED = 'Approval Required';
export const PURCHASE_ORDER_STATUS_BACKORDERED = 'Backordered';
export const PURCHASE_ORDER_STATUS_CONFIRMED = 'Confirmed';
export const PURCHASE_ORDER_STATUS_CLOSED = 'Closed';
export const PURCHASE_ORDER_STATUS_DECLINED = 'Declined';
export const PURCHASE_ORDER_STATUS_OPEN = 'Open';
export const PURCHASE_ORDER_STATUS_ORDERED = 'Ordered';
export const PURCHASE_ORDER_STATUS_PENDING_APPROVAL = 'Pending Approval';
export const PURCHASE_ORDER_STATUS_SHIPPED = 'Shipped';
export default class PurchaseOrder extends Model {
    constructor(...params) {
        super();
        this.items = [];
        this.vendor = {};
        this.setAttributes(...params);
    }

    resource() {
        return 'purchase-orders';
    }

    async relations() {
        return {
            items: await PurchaseItem,
        };
    }

    items() {
        return this.hasMany(PurchaseItem);
    }

    get statusColor() {
        switch (this.status) {
        case PURCHASE_ORDER_STATUS_ORDERED:
            return 'warning';
        case PURCHASE_ORDER_STATUS_CONFIRMED:
            return 'primary';
        case PURCHASE_ORDER_STATUS_SHIPPED:
            return 'success';
        case PURCHASE_ORDER_STATUS_PENDING_APPROVAL:
        case PURCHASE_ORDER_STATUS_APPROVAL_REQUIRED:
            return 'info';
        case PURCHASE_ORDER_STATUS_DECLINED:
        case PURCHASE_ORDER_STATUS_BACKORDERED:
            return 'danger';
        default:
            return 'default';
        }
    }
}
